// useViewerGiver — what the VIEWER may switch to "All" for a person who does
// not exist yet (the create wizard, the Add-a-person drawer): their own
// standing, as `/me` says it — an administrator or a whole-project member holds
// everything (the whole project included); a partial giver grants inside their
// reach, and their pickers are already narrowed to it. For an existing person
// the read's own `giver` wins (it knows the viewer's per-kind wildcards too).

import { useMemo } from 'react';
import { useCan } from './useCan.js';
import { useMe } from './useMe.js';
import type { UserScopeRead } from '@ems-app/schemas/users/responses';

export function useViewerGiver(projectId: string): UserScopeRead['giver'] {
  const can = useCan(projectId);
  const me = useMe();
  const wide = can('admin') || me.data?.permissions[projectId]?.scope_mode === 'all';
  return useMemo(() => ({ sites: wide, depots: wide, vehicle_pools: wide, teams: wide, whole: wide }), [wide]);
}
